import * as React from 'react';
import { compose, graphql, withApollo } from 'react-apollo';
import Home from '../Home/Home';
import Dashboard from '../Dashboard/Dashboard';
import { GetUser } from '../../queries/user';
import DashboardLayout from '../Layouts/DashboardLayout';
import HomeLayout from '../Layouts/HomeLayout';

type Props = {
  user: {
    loggedIn: boolean;
  };
};

const Main: React.SFC<Props> = ({ user }) =>
  user && user.loggedIn ? (
    <DashboardLayout>
      <Dashboard />
    </DashboardLayout>
  ) : (
    <HomeLayout>
      <Home />
    </HomeLayout>
  );

export default compose(
  withApollo,
  graphql(GetUser, {
    props: (props: any) => ({
      user: props.data.user,
    }),
  }),
)(Main);



// WEBPACK FOOTER //
// ./src/containers/Site/Main.tsx